import { Record } from "immutable";
import { Realm } from "../types/loginTypes";

export const realm = Record<Realm>({
    description: '',
    no: '',
    id: 0,
    uniqueIdentifier: ''
});
